// Export configurations for different report types

export const ExportConfigs = {
  MATTER_LEDGER: {
    reportName: "MatterLedger.trdp",
    getRequestBody: (matterId, isPreviousTransactions = false) => ({
      matterId,
      reportDocumentName: "Ledger",
      ...(isPreviousTransactions && { ReportType: "Previous" }),
    }),
  },
  SUPPLIER_LEDGER: {
    reportName: "SupplierLedger.trdp",
    getRequestBody: (SupplierRef, FromDate, ToDate, IncludeReversals) => ({
      SupplierRef,
      FromDate,
      ToDate,
      IncludeReversals,
    }),
  },
  SUPPLIER_LEDGER_PREVIOUS: {
    reportName: "SupplierLedgerPrevious.trdp",
    getRequestBody: (SupplierRef) => ({
      SupplierRef,
    }),
  },
};
